/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form, Space, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import LabelWithOriginalText from '../../../Forms/Fields/LabelWithOriginalText';
import RichTextEditor from '../../../Forms/Fields/RichTextEditor/RichTextEditor';
import ThumbsFeedbackFormItems from '../../../Forms/ThumbsFeedbackFormItems';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Text } = Typography;

const MessageNodeAAForm = ({ form, responseIndex, canEdit }) => {
  const { t } = useTranslation();
  const { botLanguages, currentBotLanguage, primaryBotLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Space className="mb-3 mt-1">
        <InfoCircleOutlined className="text-secondary" />
        <Text className="text-secondary">{t('Agent will display the below message')}</Text>
      </Space>

      <LabelWithOriginalText originalText={form.getFieldValue(['responses', responseIndex, 'options', 0, primaryBotLanguage])} />

      {
        botLanguages.map(lang => (
          <Form.Item
            key={`${responseIndex}__${lang}`}
            validateTrigger="onChange"
            name={[responseIndex, 'options', 0, lang]}
            hidden={currentBotLanguage !== lang}
            rules={[{
              required: lang === primaryBotLanguage,
              message: t('Please enter a response option or delete this field.')
            }]}
            className="mb-3"
          >
            <RichTextEditor
              placeholder={t('Option text')}
              index={responseIndex}
              shouldAutoFocus={false}
              disabled={!canEdit}
            />
          </Form.Item>
        ))
      }

      <ThumbsFeedbackFormItems responseIndex={responseIndex} form={form} canEdit={canEdit} />
    </Fragment>
  );
};

MessageNodeAAForm.propTypes = {
  form: PropTypes.object.isRequired,
  responseIndex: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired
};

export default MessageNodeAAForm;
